<!-- for restoring folder-->

<div *ngIf="isLoading"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
              role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
</div>
<div  class="dds__container" id="scrolltopdiv">
      <div class="dds__row dds__col">
        <div class="dds__col-12">
           <h3> Restoring the folder :<i style="color: #0076ce;">{{item.displayName}}</i></h3>
          </div>
          <div class="dds__col-12" *ngIf="isArticlesMapped">
           <h4 style="color: #0076ce;">* Select the files below to restore.</h4>
           </div>
        <div>
            <p   id="fileError" style="color: red;">
            </p>
            <!-- <div  *ngIf="isInvalidRequest"  >
             <h3  id="dds__modal-title1" class="dds__label-badge" style="color: red;">{{fileNameErrorMessage}}</h3>
            </div>
            <div  *ngIf="isNoFilesCheked" >
                <h4  id="dds__modal-title1" class="dds__label-badge" style="color: red;">{{noFilesChekedError}}</h4>
        </div> -->

       </div>
      </div>
      <div >
        <div class="dds__row">
          <!-- <div style="margin-top:10px;"> -->
            <div *ngIf="item.children && item.children.length && isArticlesMapped"  >
              <div class="dds__form-check dds__form-check-inline" >
               <input type="checkbox" [(ngModel)]="isSelectAllChecked" style="height: auto;margin-left:15px;" class="dds__form-check-input" (change)="SelectAllFileOptions(item.children, $event)"> <label for="item.children" class="dds__form-check-label" style="color: #0076ce;">Select All</label>
                 </div>
             </div>

             <div class="dds-row" *ngIf="!isArticlesMapped" style="color: #0076ce;margin-bottom: 5px;margin-left: 30px;">Note:* No articles mapped/created under this folder.</div>
            <!-- </div> -->
         </div>

       <div class="dds__row">

          <div  *ngFor="let children of item.children">
            <div  *ngIf="children.articleID" class="dds__col-sm-4" style="margin-bottom:16px;max-width: inherit;margin-right:20px;">
            <div class="dds__form-check dds__form-check-inline">

            <input type="checkbox" [checked]="onlyoneFileChecked"
              (change)="updateCheckedFileOptions(children, $event,item)" class="dds__form-check-input" style="height: auto;" />

              <input type="text" [(ngModel)]="children.displayName"
                     id="disabledTextInput" class="dds__form-control">

                     <p id="nameTakenError_{{children.id}}" style="display:none;">!File name already taken.


                </div>
          </div>
        </div>
      </div>

      <div class="dds__row" style="margin-left: 15px;">


        <button class="dds__btn dds__btn-primary" (click)="RestoreFolder(item)" >Restore</button>
      </div>

    </div>

